<div class="upload-staff-wrapper">
    <div class="title">{{usedInsideApp ? 'Adding Staff...' : 'Adding Users'}} <i (click)="dialogRef.close(false)" class="fal fa-times"></i></div>
           

    <mat-divider *ngIf="usedInsideApp"></mat-divider>
    <div  *ngIf="!usedInsideApp" class="sub-title">We are reading your file and creating your staff list</div>
    <div class="status-title"  [ngClass]="{'closer' : usedInsideApp }">
        <label *ngIf="loading" class="uploading">Uploading...</label>
        <label *ngIf="!loading && !isError" class="uploading">Success!</label>
        <div  *ngIf="isError && usedInsideApp" fxLayout="row" fxLayoutAlign="end start">
                <app-csv-file-upload (fileName)="setFileName($event)" [usedInsideApp]='true' (file)="acceptFile($event)"></app-csv-file-upload>

        </div>
            <label *ngIf="isError" class="error">
                There were errors found while reading your file! Please resolve the errors
                listed below and upload your template again.
            </label>

    </div>
    <div class="upload-progress">
        <i *ngIf="loading" class="fas fa-cloud-upload-alt success"></i>
        <i *ngIf="!isError && !loading" class="fad fa-cloud success"></i>
        <i *ngIf="isError && !loading" class="fad fa-cloud failure"></i>
        <div class="progress-bar-wrapper" [class]="!isError ? 'progress-bar-success' : 'progress-bar-failure'">
            <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
            <mat-progress-bar mode="determinate" *ngIf="!loading" value="100">
            </mat-progress-bar>
        </div>
        <span class="file-name"><i class="fal fa-file-csv"></i>{{ filename }}</span>
    </div>
    <div class="file-name-mobile"><i class="fal fa-file-csv"></i>{{ filename }}</div>
    <div class="staff-table" [ngClass]="{'uploadModal': usedInsideApp}">
        <app-staff-table (isValidState)="checkIfValid($event)" *ngIf="!loading && !isError" [dataSource]="dataSource">
        </app-staff-table>
        <mat-table *ngIf="!loading && isError" [dataSource]="errorList" automation-id="table-error-list-upload-staff">
            <ng-container matColumnDef="error">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    ERROR
                </mat-header-cell>
                <mat-cell *matCellDef="let error" [innerHTML]="error">
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="['error']; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['error'];"></mat-row>
        </mat-table>
    </div>
    <button *ngIf="isError && !usedInsideApp" mat-button (click)="backButtonClick(2)"
        class="icare-secondary-icon-button" automation-id="back-button-upload-staff">
        <i class="fal fa-chevron-left"></i>
        Back
    </button>
</div>